var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIos = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9309 0C26.2973 2.48883 25.2843 4.92706 23.9479 6.65213C22.5182 8.50249 20.0538 9.93363 17.6661 9.85894C17.2303 7.47612 18.3463 5.02102 19.7042 3.37064C21.1938 1.54919 23.7468 0.151787 25.9309 0ZM33.1036 35.0315C34.3346 33.145 34.7944 32.1933 35.75 30.0635C28.8 27.4205 27.6864 17.5399 34.5645 13.7476C32.4666 11.1166 29.5185 9.5915 26.7356 9.5915C24.7304 9.5915 23.3566 10.1148 22.1076 10.5905C21.0667 10.9869 20.1126 11.3503 18.9522 11.3503C17.6982 11.3503 16.5877 10.9521 15.4249 10.5352C14.1472 10.0771 12.8063 9.59632 11.1424 9.59632C8.01948 9.59632 4.69536 11.5045 2.58785 14.7667C-0.374635 19.3613 0.130688 27.9987 4.93485 35.3568C6.65199 37.9902 8.94631 40.9488 11.9471 40.9753C13.1923 40.9877 14.0208 40.616 14.9175 40.2139C15.9437 39.7536 17.0592 39.2533 18.9905 39.243C20.9332 39.2314 22.0311 39.7377 23.0437 40.2048C23.9173 40.6078 24.7275 40.9815 25.9621 40.9681C28.9653 40.944 31.3865 37.6649 33.1036 35.0315Z",
    fill: "#0B0B0A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIos);
export default ForwardRef;